<template>
  <div>
    
  </div>
</template>

<script>
import { FETCH_USER } from '@/store/constants'
import { mapActions } from 'vuex'
export default {
  name: 'Common',
  methods: {
    ...mapActions([
      FETCH_USER
    ]),
  },
  mounted(){
    this[FETCH_USER]()
  },
  beforeDestroy(){
    
  },
}
</script>

<style>

</style>